import Vue from 'vue'
import Vuex, { StoreOptions } from 'vuex'

import storage from '@/utils/storage'

Vue.use(Vuex)

let token = ''
let areaId = ''

try {
  token = storage.get('token') || ''
  areaId = storage.get('areaId') || ''
} catch (e) {
  console.error(e)
}
// 测试
if (!token && process.env.NODE_ENV === 'development') {
  console.log('ceshi')
  token = 'eyJhbGciOiJIUzUxMiJ9.eyJyYW5kb21LZXkiOiJwZmozcWsiLCJzdWIiOiJoNSYmJjNlMWNjNTNhYTBhZDQ3MGY4ZjM0MTFiYzY3OTkxZDcyIiwiZXhwIjoxNjkxNDAzMDI0LCJpYXQiOjE2OTA3OTgyMjR9.4n_eyQvsEGOF5rNKte7oGmlPSNqBf8pe8SBPdySBrsftHOACjMUnyD8jIDbBkgCzaePc2XFxGAFUES-evKcLgA'
}

export default new Vuex.Store({
  state: {
    token,
    current: {},
    managerInfo: {},
    areaId,
    areaList: [],
  },
  mutations: {
    login(state: any, tokenStr: string) {
      state.token = tokenStr
      storage.set('token', tokenStr)
    },
    logout(state: any) {
      state.token = null
      state.current = null
      storage.remove('token')
    },
    setCurrent(state: any, current: any) {
      state.current = current
    },
    setManagerInfo(state: any, managerInfo: any) {
      state.managerInfo = managerInfo
    },
    setAreaId(state: any, areaIdStr: string) {
      state.areaId = areaIdStr
      if (areaIdStr) {
        storage.set('areaId', areaIdStr)
      } else {
        storage.remove('areaId')
      }
    },
    setAreaList(state: any, areaList: any[]) {
      state.areaList = areaList
    },
  },
})
